import { useNavigate } from 'react-router-dom'

import { PermissionsChangeGroupPageModalPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import ChangeGroupModal from 'modules/permissions/components/ChangeGroupModal'

const ExternalsChangeGroupPageModalPage = () => {
  const { navigation } = useNavigation()
  const { id, userId } = useStrictParams<'id' | 'userId'>()
  const navigate = useNavigate()

  const { data, loading } = useQuery(PermissionsChangeGroupPageModalPageDocument, {
    variables: { accessId: String(userId) },
  })

  const onClose = () => {
    navigate(navigation.settings.permissions.id.externals.fullPath({ id }))
  }

  if (loading || !data?.apiCore.access) return null

  const { firstName, lastName } = data.apiCore.access

  return (
    <ChangeGroupModal
      onClose={onClose}
      userId={String(userId)}
      firstName={firstName}
      lastName={lastName}
    />
  )
}

export default ExternalsChangeGroupPageModalPage
